export default __webpack_public_path__ + "static/media/discover.148b7c3e.png";